export default __webpack_public_path__ + "static/media/kitchen5-beforeB-1440w.d1f394f8.png";